export default "__VITE_ASSET__DfEAbkK0__"